module.exports = __webpack_public_path__ + "static/53-splinternet-feb2030-ffb75553aefd2170f109ae270138eba8.jpg";